import clsx from 'clsx';
import React from 'react';

import rippleStyle from './ripple.module.styl';

const RippleIcon = ({className}: {className?: string}) => {
  return (
    <div className={clsx(className, rippleStyle.container)}>
      <div className={rippleStyle.ripple} />
      <div className={rippleStyle.ripple} />
      <div className={rippleStyle.circle}>
        <svg className={rippleStyle.icon} height='32' width='32' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
          <polyline points='20 6 9 17 4 12' />
        </svg>
      </div>
    </div>
  );
};

export {RippleIcon};
